import React, { useState, useMemo, useCallback, useEffect } from "react";
import connect from "react-redux/es/connect/connect";
import moment from "moment";
import { TTP_API_STATS_URL } from "Config";
import DateRangePicker from "../../components/common/DateRangePicker";
import BelgiumCityMapWebinar from "../../components/Admin/EventStats/EventRegistrantLinechart/BelgiumMapWebinar";
import { Cell, Pie, PieChart, Tooltip } from "recharts";
import { Col, Row } from "antd";
import t from "i18n";
import { S3_STAGING_FOLDER_URL } from "Config";
import { CommonLoader } from "../../components/common/CommonLoader";
import { getCategorieDevice, getStatsOverview, getBestTraining, getFormatRanking, getSpeakers, getLocalisation } from "../../actions/thunks/webinarStats";
// Utilitaire de formatage
const secondsToMinutes = function (s) {
    return Math.round(Number(s) / 60);
};

const minutesToHms = (d) => {
    d = Number(d);
    const h = Math.floor(d / 60);
    const m = Math.floor(d % 60);
    const hDisplay = h > 0 ? h + " h " : "00 h ";
    const mDisplay = m > 0 ? m + " min " : "00 min ";
    return hDisplay + mDisplay;
};

const DEVICE_COLORS = {
    desktop: "#1877D1",
    tablet: "#18A0FB",
    mobile: "#87CAF6",
};

const DEVICE_LABELS = {
    desktop: "Desktop",
    tablet: "Tablette",
    mobile: "Mobile",
};


const transformChartData = function (chart) {
    return chart.data.map(function (item) {
        return {
            day: item.label,
            value: Math.round(item.total_watched / 3600), // secondes → heures
            participants: item.total_participants,
            growthWatched: item.growth_watched,
            growthParticipants: item.growth_participants,
        };
    });
};

const alignChartData = function (currentData, previousData, typeCompare) {
    // Créer un dictionnaire des données précédentes par label
    const prevMap = {};
    previousData.forEach(function (p) {
        prevMap[p.day] = p;
    });

    const aligned = currentData.map(function (currentPoint) {
        let targetLabel = currentPoint.day;

        if (typeCompare === "MONTHLY") {
            if (currentPoint.day.startsWith("W")) {
                // Format semaine : W5 → W1 (soustraire 4)
                const weekNum = parseInt(currentPoint.day.replace("W", ""), 10);
                let prevWeek = weekNum - 4;
                if (prevWeek <= 0) {
                    prevWeek = 52 + prevWeek;
                }
                targetLabel = "W" + (prevWeek < 10 ? "0" + prevWeek : prevWeek);
            } else if (currentPoint.day.includes("-")) {
                // Format jour : 07-03 → 06-03
                const parts = currentPoint.day.split("-");
                if (parts.length === 2) {
                    const monthNum = parseInt(parts[0], 10);
                    const prevMonth = monthNum === 1 ? 12 : monthNum - 1;
                    targetLabel = (prevMonth < 10 ? "0" + prevMonth : "" + prevMonth) + "-" + parts[1];
                }
            }
        }
        // Chercher dans les données précédentes
        const match = prevMap[targetLabel];

        if (match) {
            return {
                day: targetLabel,
                value: match.value,
                participants: match.participants,
                growthWatched: match.growthWatched,
                growthParticipants: match.growthParticipants,
                isPrevious: true,
                isSynthetic: false,
            };
        }

        return {
            day: targetLabel,
            value: 0,
            participants: 0,
            growthWatched: 0,
            growthParticipants: 0,
            isPrevious: true,
            isSynthetic: true,
        };
    });

    return aligned;
};
//Inline styles pour les selects

const selectStyle = {
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    padding: "8px 32px 8px 16px",
    borderRadius: "20px",
    border: "none",
    color: "#fff",
    fontWeight: "500",
    fontSize: "14px",
    cursor: "pointer",
    position: "relative",
    outline: "none",
    background: "none",
    backgroundColor: "#6C7A89",
    height: "70%",
};

const wrapperStyle = {
    position: "relative",
    display: "inline-block",
};

const arrowStyle = {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    pointerEvents: "none",
    color: "white",
    fontSize: "12px",
};

// Sous-composants SVG

const ArrowDownIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" fill="none">
        <path d="M4.62593 5.48137C4.3038 5.87991 3.6962 5.87991 3.37407 5.48137L0.180423 1.53026C-0.244993 1.00395 0.129609 0.219489 0.806355 0.219489L7.19365 0.21949C7.87039 0.21949 8.24499 1.00395 7.81958 1.53026L4.62593 5.48137Z" fill="white" />
    </svg>
);

const PositiveChangeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M7.58073 10.4993V5.83268L9.6224 7.87435L10.4507 7.04602L6.9974 3.59268L3.54406 7.04602L4.3724 7.87435L6.41406 5.83268V10.4993H7.58073ZM6.9974 1.16602C7.76344 1.16602 8.52198 1.3169 9.22972 1.61005C9.93745 1.9032 10.5805 2.33288 11.1222 2.87456C11.6639 3.41623 12.0935 4.0593 12.3867 4.76703C12.6798 5.47476 12.8307 6.2333 12.8307 6.99935C12.8307 8.54645 12.2161 10.0302 11.1222 11.1241C10.0282 12.2181 8.54449 12.8327 6.9974 12.8327C6.23135 12.8327 5.47281 12.6818 4.76508 12.3886C4.05734 12.0955 3.41428 11.6658 2.87261 11.1241C1.77864 10.0302 1.16406 8.54645 1.16406 6.99935C1.16406 5.45225 1.77864 3.96852 2.87261 2.87456C3.96657 1.7806 5.4503 1.16602 6.9974 1.16602Z" fill="#02AF8E" />
    </svg>
);

const NegativeChangeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M6.41927 3.50065L6.41927 8.16732L4.3776 6.12565L3.54927 6.95398L7.0026 10.4073L10.4559 6.95398L9.6276 6.12565L7.58594 8.16732L7.58594 3.50065L6.41927 3.50065ZM7.0026 12.834C6.23656 12.834 5.47802 12.6831 4.77028 12.3899C4.06255 12.0968 3.41949 11.6671 2.87781 11.1254C2.33614 10.5838 1.90646 9.9407 1.61331 9.23297C1.32015 8.52524 1.16927 7.76669 1.16927 7.00065C1.16927 5.45355 1.78385 3.96982 2.87782 2.87586C3.97178 1.7819 5.45551 1.16732 7.0026 1.16732C7.76865 1.16732 8.52719 1.3182 9.23493 1.61135C9.94266 1.9045 10.5857 2.33419 11.1274 2.87586C12.2214 3.96982 12.8359 5.45355 12.8359 7.00065C12.8359 8.54775 12.2214 10.0315 11.1274 11.1254C10.0334 12.2194 8.5497 12.834 7.0026 12.834Z" fill="#DE4848" />
    </svg>
);

const ViewersIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M9.33366 12.25V11.0833C9.33366 10.4645 9.08783 9.871 8.65024 9.43342C8.21266 8.99583 7.61916 8.75 7.00033 8.75H3.50033C2.88149 8.75 2.28799 8.99583 1.85041 9.43342C1.41282 9.871 1.16699 10.4645 1.16699 11.0833V12.25M9.33366 1.82467C9.83402 1.95438 10.2771 2.24657 10.5935 2.65537C10.9098 3.06417 11.0814 3.56644 11.0814 4.08333C11.0814 4.60023 10.9098 5.1025 10.5935 5.5113C10.2771 5.9201 9.83402 6.21228 9.33366 6.342M12.8337 12.25V11.0833C12.8333 10.5663 12.6612 10.0641 12.3445 9.65552C12.0277 9.24692 11.5842 8.95508 11.0837 8.82583M7.58366 4.08333C7.58366 5.372 6.53899 6.41667 5.25033 6.41667C3.96166 6.41667 2.91699 5.372 2.91699 4.08333C2.91699 2.79467 3.96166 1.75 5.25033 1.75C6.53899 1.75 7.58366 2.79467 7.58366 4.08333Z" stroke="#6D7F92" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const EyeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M12.25 9.91667V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V9.91667M12.25 4.08333V2.91667C12.25 2.60725 12.1271 2.3105 11.9083 2.09171C11.6895 1.87292 11.3928 1.75 11.0833 1.75H2.91667C2.60725 1.75 2.3105 1.87292 2.09171 2.09171C1.87292 2.3105 1.75 2.60725 1.75 2.91667V4.08333M7.58333 7C7.58333 7.32217 7.32217 7.58333 7 7.58333C6.67783 7.58333 6.41667 7.32217 6.41667 7C6.41667 6.67783 6.67783 6.41667 7 6.41667C7.32217 6.41667 7.58333 6.67783 7.58333 7ZM11.0507 7.1925C11.0942 7.06786 11.0942 6.93214 11.0507 6.8075C10.7222 6.00275 10.1616 5.31406 9.44012 4.82928C8.71868 4.3445 7.86919 4.0856 7 4.0856C6.13081 4.0856 5.28132 4.3445 4.55988 4.82928C3.83844 5.31406 3.27776 6.00275 2.94933 6.8075C2.90576 6.93214 2.90576 7.06786 2.94933 7.1925C3.27776 7.99725 3.83844 8.68594 4.55988 9.17072C5.28132 9.6555 6.13081 9.9144 7 9.9144C7.86919 9.9144 8.71868 9.6555 9.44012 9.17072C10.1616 8.68594 10.7222 7.99725 11.0507 7.1925Z" stroke="#29394D" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const SeeMoreArrow = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M0.412046 0.91107C0.737483 0.585633 1.26512 0.585633 1.59056 0.91107L6.0013 5.32181L10.412 0.91107C10.7375 0.585633 11.2651 0.585633 11.5906 0.91107C11.916 1.23651 11.916 1.76414 11.5906 2.08958L6.59056 7.08958C6.26512 7.41502 5.73748 7.41502 5.41205 7.08958L0.412046 2.08958C0.0866095 1.76414 0.0866095 1.23651 0.412046 0.91107Z" fill="#29394D" />
    </svg>
);

const MedalIcon = ({ color }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M6 0H10C12.8284 0 14.2426 0 15.1213 0.87868C16 1.75736 16 3.17157 16 6V7.05573C16 9.46136 16 10.6642 15.4026 11.6308C14.8052 12.5974 13.7294 13.1353 11.5777 14.2111C9.82208 15.089 8.94427 15.5279 8 15.5279C7.05573 15.5279 6.17791 15.089 4.42229 14.2111C2.27063 13.1353 1.19479 12.5974 0.597397 11.6308C0 10.6642 0 9.46136 0 7.05573V6C0 3.17157 0 1.75736 0.87868 0.87868C1.75736 0 3.17157 0 6 0ZM8 4C7.71594 4 7.52594 4.34084 7.14595 5.02251L7.04764 5.19887C6.93966 5.39258 6.88567 5.48944 6.80148 5.55334C6.7173 5.61725 6.61245 5.64097 6.40277 5.68841L6.21186 5.73161C5.47396 5.89857 5.10501 5.98205 5.01723 6.26432C4.92945 6.54659 5.18097 6.84072 5.68403 7.42898L5.81418 7.58117C5.95713 7.74833 6.0286 7.83191 6.06076 7.93531C6.09291 8.03872 6.08211 8.15023 6.0605 8.37327L6.04082 8.57632C5.96476 9.36118 5.92674 9.75361 6.15654 9.92807C6.38635 10.1025 6.7318 9.94346 7.4227 9.62535L7.60145 9.54305C7.79778 9.45265 7.89594 9.40745 8 9.40746C8.10406 9.40746 8.20222 9.45265 8.39855 9.54305L8.5773 9.62535C9.2682 9.94346 9.61365 10.1025 9.84346 9.92807C10.0733 9.75361 10.0352 9.36118 9.95918 8.57632L9.9395 8.37327C9.9179 8.15024 9.90709 8.03871 9.93924 7.93531C9.97139 7.83191 10.0429 7.74833 10.1858 7.58118L10.316 7.42898C10.819 6.84072 11.0706 6.54659 10.9828 6.26432C10.895 5.98205 10.526 5.89857 9.78814 5.73161L9.59723 5.68841C9.38754 5.64097 9.2827 5.61725 9.19852 5.55334C9.11433 5.48944 9.06034 5.39258 8.95236 5.19887L8.85405 5.02251C8.47406 4.34084 8.28406 4 8 4Z" fill={color} />
    </svg>
);

const StarIcon = ({ color }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none" style={{ marginLeft: "-12px" }}>
        <path d="M9 0.5C9.09408 0.500003 9.19569 0.524364 9.31055 0.589844C9.38947 0.634856 9.45258 0.702606 9.5 0.816406L9.50098 0.817383L11.4502 5.44336L11.5674 5.72168L11.8672 5.74805L16.8857 6.18652C17.0609 6.21208 17.1504 6.26242 17.1953 6.30176C17.2641 6.36203 17.3228 6.44504 17.3662 6.56445C17.403 6.66581 17.41 6.76496 17.3867 6.87305C17.3691 6.95474 17.3242 7.04264 17.2178 7.1377L13.4033 10.4326L13.1748 10.6309L13.2432 10.9248L14.3857 15.835V15.8359C14.4161 15.9679 14.4014 16.0543 14.3701 16.1201C14.3164 16.2331 14.2436 16.3222 14.1514 16.3936C14.076 16.4517 13.9861 16.4878 13.8682 16.498C13.7799 16.5056 13.6896 16.4874 13.584 16.4199V16.4189L13.5723 16.4121L9.25781 13.8135L9 13.6582L8.74219 13.8135L4.42773 16.4121L4.41699 16.4189C4.31075 16.4865 4.21952 16.5055 4.12988 16.498C4.01293 16.4883 3.92459 16.4519 3.84961 16.3936C3.75628 16.321 3.68365 16.2318 3.62988 16.1191C3.59913 16.0547 3.58356 15.9684 3.61426 15.835L3.61328 15.834L4.75684 10.9248L4.8252 10.6309L4.59668 10.4326L0.783203 7.13867H0.78418C0.67774 7.04281 0.632025 6.9546 0.614258 6.87207C0.590843 6.76323 0.597557 6.66399 0.633789 6.56348C0.676251 6.44596 0.734844 6.36302 0.804688 6.30176C0.850214 6.26189 0.939004 6.21248 1.11035 6.1875L6.13281 5.74805L6.43262 5.72168L6.5498 5.44336L8.49902 0.818359L8.5 0.816406C8.54742 0.702605 8.61053 0.634856 8.68945 0.589844C8.8043 0.524372 8.90592 0.5 9 0.5Z" fill={color} stroke="white" />
    </svg>
);

const minutesToH = function (d) {
    return Math.floor(Number(d) / 60) + " h";
};

const transformOverviewData = function (data) {
    return [
        {
            title: "Total temps visionné",
            durationMinutes: secondsToMinutes(data.totalWatchTime),
            changePercent: data.growth,
        },
        {
            title: "Premium",
            durationMinutes: secondsToMinutes(data.by_type.premium.watch_time_seconds),
            changePercent: data.by_type.premium.growth,
        },
        {
            title: "Formation",
            durationMinutes: secondsToMinutes(data.by_type.formation.watch_time_seconds),
            changePercent: data.by_type.formation.growth,
        },
        {
            title: "Cycle",
            durationMinutes: secondsToMinutes(data.by_type.cycle.watch_time_seconds),
            changePercent: data.by_type.cycle.growth,
        },
        {
            title: "Saison",
            durationMinutes: secondsToMinutes(data.by_type.saison.watch_time_seconds),
            changePercent: data.by_type.saison.growth,
        },
        {
            title: "Essentiel",
            durationMinutes: secondsToMinutes(data.by_type.essential.watch_time_seconds),
            changePercent: data.by_type.essential.growth,
        },
    ];
};

//Composant principal

const WebinarStatisticsPage = ({ issuerId, getCategorieDevice, getStatsOverview, getBestTraining, getFormatRanking, getSpeakers, getLocalisation }) => {
    console.log("issuerId:", issuerId);
    const [period, setPeriod] = useState("Les 7 derniers jours");
    const [year, setYear] = useState("2026");
    const [startDate, setStartDate] = useState(moment().year(2026).subtract(6, "days")._d);
    const [endDate, setEndDate] = useState(moment().year(2026)._d);
    const [hoveredPoint, setHoveredPoint] = useState(null);
    const [typeCompare, setTypeCompare] = useState("YEARLY");
    const [showMoreRankings, setShowMoreRankings] = useState(false);
    const [showMoreSpeakers, setShowMoreSpeakers] = useState(false);
    const [chartLoading, setChartLoading] = useState(false);
    const [deviceData, setDeviceData] = useState([
        { name: "Desktop", value: 90.9, color: "#1877D1" },
        { name: "Tablette", value: 1, color: "#18A0FB" },
        { name: "Mobile", value: 8.1, color: "#87CAF6" },
    ]);
    const [deviceLoading, setDeviceLoading] = useState(false);
    const [chartApiData, setChartApiData] = useState(null);
    const [metricsData, setMetricsData] = useState([]);
    const [coursesData, setCoursesData] = useState([]);
    const [coursesLoading, setCoursesLoading] = useState(false);


    const BADGE_COLORS = {
        gold: "#FFC43A",
        silver: "#BDB7A8",
        bronze: "#D99377",
    };

    const [speakersData, setSpeakersData] = useState([]);
    const [speakersLoading, setSpeakersLoading] = useState(false);

    const STAR_COLORS = ["#FFC43A", "#BDB7A8", "#D99377"];
    const [rankingData, setRankingData] = useState([]);
    const [rankingLoading, setRankingLoading] = useState(false);
    const [cityData, setCityData] = useState({});
    const [topCities, setTopCities] = useState([]);
    const [localisationLoading, setLocalisationLoading] = useState(false);
    const [mapThresholds, setMapThresholds] = useState({ high: 75, mid: 50, low: 25 });
    const isMinusDisabled = mapThresholds.low - 600 <= 10;

    const daysDiff = moment(endDate).diff(moment(startDate), "days");
    const isMonthlyAllowed = daysDiff <= 30;

    const transformLocalisationData = function (provinces) {
        const mapData = {};
        provinces.forEach(function (p) {
            mapData[p.province] = [Math.round(p.total_watched / 60)];
        });

        const autres = provinces.find(function (p) { return p.province === "Autres"; });
        const filtered = provinces.filter(function (p) { return p.province !== "Autres"; });

        // Calculer les seuils dynamiquement
        const durations = filtered.map(function (p) { return Math.round(p.total_watched / 60); });
        const maxDuration = Math.max.apply(null, durations) || 1;
        const thresholds = {
            high: Math.round(maxDuration * 0.75),
            mid: Math.round(maxDuration * 0.50),
            low: Math.round(maxDuration * 0.25),
        };



        const topFive = filtered.slice(0, 5).map(function (p) {
            return {
                region: p.province,
                duration: Math.round(p.total_watched / 60),
            };
        });

        if (autres) {
            topFive.push({
                region: "Autres",
                duration: Math.round(autres.total_watched / 60),
                isAutres: true,
            });
        }

        return { mapData: mapData, topFive: topFive, thresholds: thresholds };
    };

    useEffect(function () {
        if (!isMonthlyAllowed && typeCompare === "MONTHLY") {
            setTypeCompare("YEARLY");
        }
    }, [isMonthlyAllowed]);

    useEffect(function () {
        if (!issuerId) return;
        setLocalisationLoading(true);

        getLocalisation(issuerId, {
            startDate: moment(startDate).format("YYYY-MM-DD"),
            endDate: moment(endDate).format("YYYY-MM-DD"),
        })
            .then(function (res) {
                const result = res.data;
                if (result.success && result.data && result.data.provinces) {
                    const transformed = transformLocalisationData(result.data.provinces);
                    setCityData(transformed.mapData);
                    setTopCities(transformed.topFive);
                    setMapThresholds(transformed.thresholds);
                }
            })
            .catch(function (err) {
                console.error("Erreur fetch localisation:", err);
            })
            .finally(function () {
                setLocalisationLoading(false);
            });
    }, [startDate, endDate, issuerId]);

    const transformFormatRanking = function (formats) {
        return formats.map(function (f) {
            return {
                id: f.rank,
                rank: f.rank,
                title: f.name,
                viewers: f.total_participants,
                duration: Math.round(f.total_watched / 60),
            };
        });
    };

    useEffect(function () {
        if (!issuerId) return;
        setRankingLoading(true);

        getFormatRanking(issuerId, {
            startDate: moment(startDate).format("YYYY-MM-DD"),
            endDate: moment(endDate).format("YYYY-MM-DD"),
        })
            .then(function (res) {
                const result = res.data;
                if (result.success && result.data && result.data.formats) {
                    setRankingData(transformFormatRanking(result.data.formats));
                }
            })
            .catch(function (err) {
                console.error("Erreur fetch format-ranking:", err);
            })
            .finally(function () {
                setRankingLoading(false);
            });
    }, [startDate, endDate, issuerId]);

    const transformSpeakersData = function (speakers) {
        return speakers.map(function (s) {
            let imageUrl = null;
            if (s.picture_url) {
                imageUrl = S3_STAGING_FOLDER_URL + "/events-folder" + s.picture_url;
            }
            return {
                id: s.rank,
                name: s.name,
                title: s.headline || "",
                image: imageUrl,
            };
        });
    };



    useEffect(function () {
        if (!issuerId) return;
        setSpeakersLoading(true);

        getSpeakers(issuerId, {
            startDate: moment(startDate).format("YYYY-MM-DD"),
            endDate: moment(endDate).format("YYYY-MM-DD"),
        })
            .then(function (res) {
                const result = res.data;
                if (result.success && result.data && result.data.speakers) {
                    setSpeakersData(transformSpeakersData(result.data.speakers));
                }
            })
            .catch(function (err) {
                console.error("Erreur fetch speakers:", err);
            })
            .finally(function () {
                setSpeakersLoading(false);
            });
    }, [startDate, endDate, issuerId]);




    const transformTrainingsData = function (trainings) {
        return trainings
            .filter(function (t) {
                return t.name && t.name !== "" && t.image_url && t.image_url !== "";
            })
            .map(function (t) {
                let imageUrl = null;
                if (t.image_url) {
                    if (t.image_url.startsWith("/")) {
                        imageUrl = S3_STAGING_FOLDER_URL + t.image_url.replace("eventsFolder", "events-folder");
                    } else {
                        imageUrl = t.image_url;
                    }
                }
                return {
                    title: t.name,
                    image: imageUrl,
                    viewers: t.total_participants,
                    durationMinutes: Math.round(t.total_watched / 60),
                    badge: t.badge,
                };
            });
    };

    useEffect(function () {
        if (!issuerId) return;
        setCoursesLoading(true);

        getBestTraining(issuerId, {
            startDate: moment(startDate).format("YYYY-MM-DD"),
            endDate: moment(endDate).format("YYYY-MM-DD"),
        })
            .then(function (res) {
                const result = res.data;
                if (result.success && result.data && result.data.trainings) {
                    setCoursesData(transformTrainingsData(result.data.trainings));
                }
            })
            .catch(function (err) {
                console.error("Erreur fetch best-training:", err);
            })
            .finally(function () {
                setCoursesLoading(false);
            });
    }, [startDate, endDate, issuerId]);

    useEffect(function () {
        setDeviceLoading(true);
        setDeviceData([]);

        getCategorieDevice({
            startDate: moment(startDate).format("YYYY-MM-DD"),
            endDate: moment(endDate).format("YYYY-MM-DD"),
        })
            .then(function (res) {
                const result = res.data;
                if (result.success && result.data && result.data.devices) {
                    setDeviceData(transformDeviceData(result.data.devices));
                }
                setDeviceLoading(false);
            })
            .catch(function (err) {
                console.error("Erreur fetch devices:", err);
                // Pas de setDeviceLoading(false) ici → le loader reste affiché
            });
    }, [startDate, endDate]);

    useEffect(function () {
        if (!issuerId) return;
        setChartLoading(true);

        const currentStart = moment(startDate).format("YYYY-MM-DD");
        const currentEnd = moment(endDate).format("YYYY-MM-DD");

        let previousStart, previousEnd;
        const daysDiff = moment(endDate).diff(moment(startDate), "days");

        if (typeCompare === "MONTHLY") {
            if (daysDiff <= 31) {
                previousStart = moment(startDate).subtract(1, "months").format("YYYY-MM-DD");
                previousEnd = moment(endDate).subtract(1, "months").format("YYYY-MM-DD");
            } else {
                previousEnd = moment(startDate).subtract(1, "days").format("YYYY-MM-DD");
                previousStart = moment(previousEnd).subtract(daysDiff, "days").format("YYYY-MM-DD");
            }
        } else {
            previousStart = moment(startDate).subtract(1, "years").format("YYYY-MM-DD");
            previousEnd = moment(endDate).subtract(1, "years").format("YYYY-MM-DD");
        }

        getStatsOverview(issuerId, {
            startDate: currentStart,
            endDate: currentEnd,
        })
            .then(function (res) {
                const currentResult = res.data;

                if (!currentResult.success || !currentResult.data) {
                    setChartLoading(false);
                    return;
                }

                setMetricsData(transformOverviewData(currentResult.data));

                if (!currentResult.data.chart || !currentResult.data.chart.data) {
                    setChartLoading(false);
                    return;
                }

                const currentChartData = transformChartData(currentResult.data.chart);

                setChartApiData({
                    currentPeriod: currentChartData,
                    previousPeriod: null,
                    granularity: currentResult.data.chart.granularity,
                    totalSeconds: currentResult.data.totalWatchTime,
                    previousTotalSeconds: 0,
                    previousLoaded: false,
                    users: {
                        current: currentChartData.reduce(function (sum, p) { return sum + p.participants; }, 0),
                        previous: 0,
                    },
                });

                getStatsOverview(issuerId, {
                    startDate: previousStart,
                    endDate: previousEnd,
                })
                    .then(function (prevRes) {
                        const prevResult = prevRes.data;

                        if (prevResult.success && prevResult.data && prevResult.data.chart && prevResult.data.chart.data) {
                            const previousChartData = transformChartData(prevResult.data.chart);
                            const alignedPrevious = alignChartData(currentChartData, previousChartData, typeCompare);

                            setChartApiData({
                                currentPeriod: currentChartData,
                                previousPeriod: alignedPrevious,
                                granularity: currentResult.data.chart.granularity,
                                totalSeconds: currentResult.data.totalWatchTime,
                                previousTotalSeconds: prevResult.data.totalWatchTime,
                                previousLoaded: true,
                                users: {
                                    current: currentChartData.reduce(function (sum, p) { return sum + p.participants; }, 0),
                                    previous: previousChartData.reduce(function (sum, p) { return sum + p.participants; }, 0),
                                },
                            });
                        } else {
                            setChartApiData(function (prev) {
                                return Object.assign({}, prev, { previousLoaded: true });
                            });
                        }
                        setChartLoading(false);
                    })
                    .catch(function (err) {
                        console.error("Erreur fetch previous:", err);
                        setChartApiData(function (prev) {
                            return Object.assign({}, prev, { previousLoaded: true });
                        });
                        setChartLoading(false);
                    });
            })
            .catch(function (err) {
                console.error("Erreur fetch current:", err);
                setChartLoading(false);
            });
    }, [startDate, endDate, issuerId, typeCompare]);



    // Transforme la réponse API en format utilisable par le PieChart
    const transformDeviceData = function (apiDevices) {
        return Object.keys(apiDevices).map(function (key) {
            return {
                name: DEVICE_LABELS[key] || key,
                value: apiDevices[key].percentage,
                color: DEVICE_COLORS[key] || "#ccc",
            };
        });
    };


    const chartData = chartApiData;

    const formattedMetrics = useMemo(function () {
        return metricsData.map(function (m) {
            return {
                title: m.title,
                durationMinutes: m.durationMinutes,
                value: minutesToHms(m.durationMinutes).split("h")[0].trim() + " h",
                subValue: (minutesToHms(m.durationMinutes).split("h")[1] || "").trim() || "00 min",
                change: (m.changePercent >= 0 ? "+ " : "- ") + Math.abs(m.changePercent) + " %",
                changeType: m.changePercent >= 0 ? "positive" : "negative",
            };
        });
    }, [metricsData]);

    //Handlers
    const handlePeriodChange = useCallback(function (e) {
        const val = e.target.value;
        setPeriod(val);

        const now = moment().year(year);
        const end = moment().year(year);

        switch (val) {
            case "Les 7 derniers jours":
                setStartDate(moment(end).subtract(6, "days")._d);
                setEndDate(end._d);
                break;
            case "Les 30 derniers jours":
                setStartDate(moment(end).subtract(30, "days")._d);
                setEndDate(end._d);
                break;
            case "Les 3 derniers mois":
                setStartDate(moment(end).subtract(3, "months")._d);
                setEndDate(end._d);
                break;
            case "Cette année":
                setStartDate(moment(now).startOf("year")._d);
                if (parseInt(year) < moment().year()) {
                    setEndDate(moment(now).endOf("year")._d);
                } else {
                    setEndDate(end._d);
                }
                break;
            default:
                setStartDate(moment(end).subtract(30, "days")._d);
                setEndDate(end._d);
        }
    }, [year]);

    const handleYearChange = useCallback(function (e) {
        const newYear = e.target.value;
        setYear(newYear);

        const end = moment().year(newYear);

        switch (period) {
            case "Les 7 derniers jours":
                setStartDate(moment(end).subtract(6, "days")._d);
                setEndDate(end._d);
                break;
            case "Les 30 derniers jours":
                setStartDate(moment(end).subtract(30, "days")._d);
                setEndDate(end._d);
                break;
            case "Les 3 derniers mois":
                setStartDate(moment(end).subtract(3, "months")._d);
                setEndDate(end._d);
                break;
            case "Cette année":
                setStartDate(moment(end).startOf("year")._d);
                if (parseInt(newYear) < moment().year()) {
                    setEndDate(moment(end).endOf("year")._d);
                } else {
                    setEndDate(end._d);
                }
                break;
            default:
                setStartDate(moment(end).subtract(30, "days")._d);
                setEndDate(end._d);
        }
    }, [period]);

    const handleDateRangeChange = useCallback((start, end) => {
        setStartDate(start);
        setEndDate(end);
    }, []);

    const handleMouseEnter = useCallback((point, event) => {
        setHoveredPoint({
            ...point,
            x: event.clientX,
            y: event.clientY,
        });
    }, []);

    const handleMouseLeave = useCallback(() => {
        setHoveredPoint(null);
    }, []);

    //Label de période
    const getPeriodLabel = useCallback(() => {
        if (period === "Période") {
            return `du ${moment(startDate).format("DD MMM")} au ${moment(endDate).format("DD MMM")}`;
        }

        let end;
        let start;

        switch (period) {
            case "Les 7 derniers jours":
                end = moment().year(year);
                start = moment().year(year).subtract(7, "days");
                break;
            case "Les 30 derniers jours":
                end = moment().year(year);
                start = moment().year(year).subtract(30, "days");
                break;
            case "Les 3 derniers mois":
                end = moment().year(year);
                start = moment().year(year).subtract(3, "months");
                break;
            case "Cette année":
                start = moment().year(year).startOf("year");
                if (parseInt(year) < moment().year()) {
                    end = moment().year(year).endOf("year");
                } else {
                    end = moment();
                }
                break;
            default:
                end = moment().year(year);
                start = moment().year(year).subtract(30, "days");
        }

        return `du ${start.format("DD MMM")} au ${end.format("DD MMM")}`;
    }, [period, startDate, endDate, year]);

    // Rendu du graphique SVG
    const renderChart = () => {
        const chartWidth = 1075;
        const chartHeight = 300;
        const paddingLeft = 40;
        const paddingRight = 60;
        const paddingTop = 40;
        const paddingBottom = 40;

        const getX = (index) => {
            if (chartData.currentPeriod.length <= 1) return chartWidth / 2;
            return paddingLeft + (index * (chartWidth - paddingLeft - paddingRight)) / (chartData.currentPeriod.length - 1);
        };
        const getY = (value) => chartHeight - paddingBottom - (value * (chartHeight - paddingTop - paddingBottom)) / maxValue;

        // Calcule maxValue dynamiquement selon les données
        let allValues = chartData.currentPeriod.map(function (p) { return p.value; });
        if (chartData.previousPeriod) {
            allValues = allValues.concat(chartData.previousPeriod.map(function (p) { return p.value; }));
        }
        const dataMax = Math.max.apply(null, allValues);
        const maxValue = Math.ceil(dataMax / 10) * 10 || 10; // arrondi à la dizaine supérieure

        const currentPath = chartData.currentPeriod
            .map((point, index) => `${index === 0 ? "M" : "L"} ${getX(index)} ${getY(point.value)}`)
            .join(" ");

        // previousPeriod seulement si disponible
        let previousPath = null;
        if (chartData.previousPeriod) {
            previousPath = chartData.previousPeriod
                .map((point, index) => `${index === 0 ? "M" : "L"} ${getX(index)} ${getY(point.value)}`)
                .join(" ");
        }

        // Générer les lignes de grille dynamiquement
        const gridLines = [];
        for (let i = 0; i <= maxValue; i += Math.ceil(maxValue / 3)) {
            gridLines.push(i);
        }

        return (
            <div className="chart-container">
                <svg viewBox={"0 0 " + chartWidth + " " + chartHeight} preserveAspectRatio="xMidYMid meet" style={{ width: "100%", height: "auto" }} className="chart-svg">
                    {/* 1. Grille */}
                    {gridLines.map((value) => (
                        <g key={value}>
                            <line x1={paddingLeft} y1={getY(value)} x2={chartWidth - paddingRight} y2={getY(value)} stroke="#f0f0f0" strokeWidth="1" />
                            <text x={chartWidth - 20} y={getY(value) - 5} fontSize="12" fill="#999" textAnchor="end">
                                {value} H
                            </text>
                        </g>
                    ))}

                    {/* 2. Courbe précédente (en dessous) */}
                    {previousPath && (
                        <path d={previousPath} fill="none" stroke="#b2bcc6" strokeWidth="2" strokeDasharray="4,4" />
                    )}

                    {/* 3. Points précédents (en dessous) */}
                    {chartData.previousPeriod && chartData.previousPeriod.map((point, index) => (
                        <circle
                            key={"prev-" + index}
                            cx={getX(index)}
                            cy={getY(point.value)}
                            r="4"
                            fill="#b2bcc6"
                            onMouseEnter={(e) => handleMouseEnter(point, e)}
                            onMouseLeave={handleMouseLeave}
                            style={{ cursor: "pointer" }}
                        />
                    ))}

                    {/* 4. Courbe actuelle (au-dessus) */}
                    <path d={currentPath} fill="none" stroke="#18A0FB" strokeWidth="2" />

                    {/* 5. Points actuels (au-dessus de tout) */}
                    {chartData.currentPeriod.map((point, index) => (
                        <g key={index}>
                            {/* Zone de hover invisible plus grande */}
                            <circle
                                cx={getX(index)}
                                cy={getY(point.value)}
                                r="8"
                                fill="transparent"
                                onMouseEnter={(e) => handleMouseEnter(point, e)}
                                onMouseLeave={handleMouseLeave}
                                style={{ cursor: "pointer" }}
                            />
                            {/* Point visible */}
                            <circle
                                cx={getX(index)}
                                cy={getY(point.value)}
                                r="4"
                                fill="#18A0FB"
                                pointerEvents="none"
                            />
                        </g>
                    ))}

                    {/* Labels */}
                    {chartData.currentPeriod.map((point, index) => (
                        <text key={index} x={getX(index)} y={chartHeight - 10} fontSize="12" fill="#b2bcc6" textAnchor="middle">
                            {point.day}
                        </text>
                    ))}
                </svg>


            </div>
        );
    };

    return (
        <div className="webinar-statistics-page" style={{ backgroundColor: "#F7F9FB" }}>
            {/* Header */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "#F7F9FB", padding: "22px 55px 30px" }}>
                <h2 style={{ color: "var(--dark-1, #29394D)", fontFamily: "Roboto", fontSize: "32px", fontWeight: "500", textTransform: "uppercase" }}>
                    STATISTIQUES WEBINAR
                </h2>

                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    {period !== "Période" && (
                        <span style={{ color: "var(--Dark-1, #29394D)", fontFamily: "Roboto", fontSize: "18px", fontWeight: "500", letterSpacing: "0.36px" }}>
                            {getPeriodLabel()}
                        </span>
                    )}

                    {period === "Période" && <DateRangePicker onChangeDateRange={handleDateRangeChange} />}

                    <div style={wrapperStyle}>
                        <select value={period} onChange={handlePeriodChange} style={selectStyle}>
                            <option>Les 7 derniers jours</option>
                            <option>Les 30 derniers jours</option>
                            <option>Les 3 derniers mois</option>
                            <option>Cette année</option>
                            <option>Période</option>
                        </select>
                        <span style={arrowStyle}><ArrowDownIcon /></span>
                    </div>

                    <div style={wrapperStyle}>
                        <select value={year} onChange={handleYearChange} style={selectStyle}>
                            <option>2023</option>
                            <option>2024</option>
                            <option>2025</option>
                            <option>2026</option>
                        </select>
                        <span style={arrowStyle}><ArrowDownIcon /></span>
                    </div>
                </div>
            </div>

            {/*Contenu principal  */}
            <div className="webinar-content" style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
                {/* Colonne gauche */}
                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                    {/* Rapport de visionnages */}
                    <div className="dashboard">
                        <div className="header">
                            <div className="header-left">
                                <h1 className="title">Rapport de visionnages</h1>
                                <p className="subtitle">{getPeriodLabel()}</p>
                            </div>
                            <div className="header-right">
                                <span className="compare-text">Comparer cette période par rapport au :</span>
                                <div className="button-group m-0">
                                    <button
                                        className={"button " + (typeCompare === "MONTHLY" ? "button-active" : "") + (!isMonthlyAllowed ? " button-disabled" : "")}
                                        onClick={function () {
                                            if (isMonthlyAllowed) {
                                                setTypeCompare("MONTHLY");
                                            }
                                        }}
                                        style={!isMonthlyAllowed ? { cursor: "not-allowed", opacity: 0.5 } : {}}
                                    >
                                        Mois précédent
                                    </button>
                                    <button
                                        className={"button " + (typeCompare === "YEARLY" ? "button-active" : "")}
                                        onClick={function () { setTypeCompare("YEARLY"); }}
                                    >
                                        Année précédente
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="metrics-grid">
                            {formattedMetrics.length > 0 && (
                                <div className="metrics-grid">
                                    {formattedMetrics.map((metric, index) => (
                                        <div key={index} className={"metric-card " + (index === 0 ? "active-card" : "")}>
                                            <div className="metric-title">{metric.title}</div>
                                            <div className="metric-value">
                                                <span className="value-main">{metric.value}</span>
                                                <span className="value-sub">{metric.subValue}</span>
                                            </div>
                                            <div className={`metric-change ${metric.changeType}`}>
                                                <span className="change-icon">
                                                    {metric.changeType === "positive" ? <PositiveChangeIcon /> : <NegativeChangeIcon />}
                                                </span>
                                                {metric.change}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        {/* Summary */}
                        {!chartLoading && chartData && (
                            <div className="summary">
                                {chartData.previousLoaded ? (
                                    <React.Fragment>
                                        <span className={"summary-text " + (chartData.totalSeconds >= chartData.previousTotalSeconds ? "positive" : "negative")}>
                                            {chartData.totalSeconds >= chartData.previousTotalSeconds ? "+ " : "- "}
                                            {minutesToHms(Math.round(Math.abs(chartData.totalSeconds - chartData.previousTotalSeconds) / 60))}
                                            {chartData.totalSeconds >= chartData.previousTotalSeconds ? " supplémentaires" : " en moins"}
                                        </span>
                                        <span className="summary-text-secondary"> comparé à {typeCompare === "MONTHLY" ? "la période précédente" : "l'année précédente"}</span>
                                    </React.Fragment>
                                ) : (
                                    <CommonLoader />
                                )}
                            </div>
                        )}

                        {/* Chart */}
                        {chartLoading ? (
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px", width: "100%" }}>
                                <CommonLoader />
                            </div>
                        ) : chartData ? renderChart() : (
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px", width: "100%" }}>
                                <CommonLoader />
                            </div>
                        )}

                        {/* Tooltip sorti du chart */}
                        {hoveredPoint && (
                            <div className="tooltip-w" style={{
                                position: "fixed",
                                left: hoveredPoint.x > window.innerWidth - 250 ? hoveredPoint.x - 230 : hoveredPoint.x + 10,
                                top: hoveredPoint.y - 80,
                                zIndex: 1000,
                                pointerEvents: "none",
                            }}>
                                <div className="tooltip-header">
                                    <span className="tooltip-date" style={{ color: hoveredPoint.isPrevious ? "#6D7F92" : "#18A0FB" }}>
                                        {hoveredPoint.day}
                                    </span>
                                </div>
                                <div className="tooltip-content">
                                    <div className="tooltip-row">
                                        <div className="tooltip-icon">
                                            <EyeIcon />
                                        </div>
                                        <div className="tooltip-data">
                                            <div className="tooltip-value">{hoveredPoint.value} h</div>
                                            {!hoveredPoint.isSynthetic && hoveredPoint.growthWatched !== undefined && (
                                                <div className={"tooltip-change " + (hoveredPoint.growthWatched >= 0 ? "positive" : "negative")}>
                                                    {hoveredPoint.growthWatched >= 0 ? "+" : ""}{hoveredPoint.growthWatched} %
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div style={{ width: "0.5px", background: "var(--gris-2, #E1E4E8)" }} />
                                    <div className="tooltip-row">
                                        <div className="tooltip-icon">
                                            <ViewersIcon />
                                        </div>
                                        <div className="tooltip-data">
                                            <div className="tooltip-value">{hoveredPoint.participants || 0} participants</div>
                                            {!hoveredPoint.isSynthetic && hoveredPoint.growthParticipants !== undefined && (
                                                <div className={"tooltip-change " + (hoveredPoint.growthParticipants >= 0 ? "positive" : "negative")}>
                                                    {hoveredPoint.growthParticipants >= 0 ? "+" : ""}{hoveredPoint.growthParticipants} %
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {/* Légende */}
                        {!chartLoading && chartData && (
                            <div className="legend">
                                <div className="legend-item">
                                    <div className="legend-line current" />
                                    <span className="legend-text">Période actuelle</span>
                                    <span className="legend-count">( {chartData.users ? chartData.users.current : 0} participants )</span>
                                </div>
                                {chartData.previousPeriod && (
                                    <div className="legend-item">
                                        <div className="legend-line previous" />
                                        <span className="legend-text">{typeCompare === "MONTHLY" ? "Mois précédent" : "Année précédente"}</span>
                                        <span className="legend-count">( {chartData.users ? chartData.users.previous : 0} participants )</span>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    {/* Top régions + Catégories appareil */}
                    <div className="top-regions-categories">
                        <div className="top-regions">
                            <div className="map-container">
                                {localisationLoading ? (
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px", width: "100%" }}>
                                        <CommonLoader />
                                    </div>
                                ) : (
                                    <React.Fragment>
                                        <BelgiumCityMapWebinar
                                            cityPercentageData={cityData}
                                            firstVariant={mapThresholds.high}
                                            secondVariant={mapThresholds.mid}
                                            thirdVariant={mapThresholds.low}
                                        />
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "12px", marginTop: "8px", fontSize: "11px", color: "#6D7F92", position: "relative", zIndex: 2 }}>
                                            <span
                                                onClick={function () {
                                                    if (!isMinusDisabled) {
                                                        setMapThresholds({
                                                            high: mapThresholds.high - 600,
                                                            mid: mapThresholds.mid - 600,
                                                            low: mapThresholds.low - 600,
                                                        });
                                                    }
                                                }}
                                                style={{
                                                    cursor: isMinusDisabled ? "not-allowed" : "pointer",
                                                    fontWeight: "bold",
                                                    fontSize: "16px",
                                                    userSelect: "none",
                                                    position: "relative",
                                                    zIndex: 2,
                                                    opacity: isMinusDisabled ? 0.3 : 1,
                                                }}
                                            >
                                                -
                                            </span>
                                            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                <span style={{ width: "14px", height: "14px", backgroundColor: "#2d74d0", display: "inline-block" }} />
                                                <span>&gt; {minutesToH(mapThresholds.high)}</span>
                                            </div>
                                            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                <span style={{ width: "14px", height: "14px", backgroundColor: "#4582e4", display: "inline-block" }} />
                                                <span>&gt; {minutesToH(mapThresholds.mid)}</span>
                                            </div>
                                            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                <span style={{ width: "14px", height: "14px", backgroundColor: "#88b0ed", display: "inline-block" }} />
                                                <span>&gt; {minutesToH(mapThresholds.low)}</span>
                                            </div>
                                            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                <span style={{ width: "14px", height: "14px", backgroundColor: "#dddddd", display: "inline-block" }} />
                                                <span>&lt; {minutesToH(mapThresholds.low)}</span>
                                            </div>
                                            <span
                                                onClick={function () {
                                                    setMapThresholds({
                                                        high: mapThresholds.high + 600,
                                                        mid: mapThresholds.mid + 600,
                                                        low: mapThresholds.low + 600,
                                                    });
                                                }}
                                                style={{ cursor: "pointer", fontWeight: "bold", fontSize: "16px", userSelect: "none", position: "relative", zIndex: 2 }}
                                            >
                                                +
                                            </span>
                                        </div>
                                    </React.Fragment>
                                )}
                            </div>
                            <div className="top-regions-container">
                                <div className="top-regions-header">
                                    <h3 className="top-regions-title">Top régions</h3>
                                    <p className="date-range">{getPeriodLabel()}</p>
                                </div>
                                {localisationLoading ? (
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px", width: "100%" }}>
                                        <CommonLoader />
                                    </div>
                                ) : topCities.length > 0 ? (
                                    <div style={{ color: "#29394D" }}>
                                        {topCities.map(function (item, index) {
                                            return (
                                                <React.Fragment key={index}>
                                                    <Row style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0px" }}>
                                                        <Col span={19}>{item.region}</Col>
                                                        <Col span={5} style={{ display: "flex", justifyContent: "flex-end", whiteSpace: "nowrap" }}>{minutesToHms(item.duration)}</Col>
                                                    </Row>
                                                    {!item.isAutres && (
                                                        <div style={{ width: "100%", height: "2px", backgroundColor: "#B2BCC6" }}>
                                                            <div style={{ width: Math.round((item.duration / topCities[0].duration) * 100) + "%", height: "2px", backgroundColor: "#18A0FB" }} />
                                                        </div>
                                                    )}
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
                                        <span style={{ color: "#999", fontSize: "14px" }}>Aucune donnée disponible</span>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="categories">
                            <div className="categories-header">
                                <h3 className="categories-title">Categories de l&apos;appareil</h3>
                                <p className="categories-date-range">{getPeriodLabel()}</p>
                            </div>
                            {deviceLoading ? (
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
                                    <CommonLoader />
                                </div>
                            ) : (
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <PieChart width={200} height={200}>
                                        <Pie data={deviceData} cx="50%" cy="50%" innerRadius={50} outerRadius={70} dataKey="value">
                                            {deviceData.map(function (entry, index) {
                                                return <Cell key={"cell-" + index} fill={entry.color} />;
                                            })}
                                        </Pie>
                                        <Tooltip />
                                    </PieChart>

                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 10, marginTop: 10 }}>
                                        {deviceData.map(function (entry, index) {
                                            return (
                                                <React.Fragment key={index}>
                                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                        <div style={{ display: "flex", alignItems: "center" }}>
                                                            <span style={{ width: 10, height: 10, borderRadius: "50%", background: entry.color, marginRight: 5 }} />
                                                            <span style={{ fontSize: 12, color: "#2C3E50", fontWeight: 500 }}>{t(entry.name)}</span>
                                                        </div>
                                                        <span style={{ color: "#29394D", fontSize: 20, fontWeight: 500, marginLeft: 5 }}>{entry.value}%</span>
                                                    </div>
                                                    {index < 2 && <div style={{ width: "1px", height: "60px", backgroundColor: "#E1E4E8" }} />}
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Formations les plus regardées */}
                    <div className="most-viewed-courses">
                        <div className="most-viewed-courses-header">
                            <h3 className="most-viewed-courses-header-title">Formations les plus regardées</h3>
                            <p className="most-viewed-courses-header-date">{getPeriodLabel()}</p>
                        </div>
                        {coursesLoading ? (
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px", width: "100%" }}>
                                <CommonLoader />
                            </div>
                        ) : coursesData.length > 0 ? (
                            <div className="most-viewed-courses-list">
                                {coursesData.map(function (course, index) {
                                    return (
                                        <div key={index} className="most-viewed-course">
                                            {course.image ? (
                                                <img
                                                    src={course.image}
                                                    alt={course.title}
                                                    style={{ width: "100px", height: "50px", flexShrink: 0, borderRadius: "5px", objectFit: "cover" }}
                                                    onError={function (e) { e.target.style.display = "none"; }}
                                                />
                                            ) : (
                                                <div style={{ width: "100px", height: "50px", flexShrink: 0, borderRadius: "5px", backgroundColor: "#F1F2F4" }} />
                                            )}
                                            <div style={{ display: "flex", alignItems: "center", gap: "30px", flex: "1 0 0", alignSelf: "stretch", width: "100%" }}>
                                                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-start", gap: "3px", flex: "1 0 0", alignSelf: "stretch" }}>
                                                    <h4 className="most-viewed-course-title">{course.title}</h4>
                                                </div>
                                                <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "30px" }}>
                                                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                        <ViewersIcon />
                                                        <span style={{ overflow: "hidden", color: "#6D7F92", textOverflow: "ellipsis", fontFamily: "Roboto", fontSize: "12px", fontWeight: 500 }}>
                                                            {course.viewers}
                                                        </span>
                                                    </div>
                                                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                        <div style={{ overflow: "hidden", color: "#29394D", textAlign: "right", textOverflow: "ellipsis", fontFamily: "Roboto", fontSize: "12px", fontWeight: 500 }}>
                                                            {minutesToHms(course.durationMinutes)}
                                                        </div>
                                                        <EyeIcon />
                                                    </div>
                                                </div>
                                                {course.badge && BADGE_COLORS[course.badge] ? (
                                                    <MedalIcon color={BADGE_COLORS[course.badge]} />
                                                ) : (
                                                    <div style={{ width: "16px", height: "16px" }} />
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
                                <span style={{ color: "#999", fontSize: "14px" }}>Aucune donnée disponible</span>
                            </div>
                        )}
                    </div>
                </div>

                {/*Colonne droite */}
                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                    {/* Classement des formats les plus populaires */}
                    <div className="ranking-container">
                        <div className="ranking-header">
                            <h1 className="main-title">Classement des formats les plus populaires</h1>
                            <p className="date-range">{getPeriodLabel()}</p>
                        </div>

                        {rankingLoading ? (
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
                                <CommonLoader />
                            </div>
                        ) : rankingData.length > 0 ? (
                            <React.Fragment>
                                <div className="ranking-list">
                                    {(showMoreRankings ? rankingData.slice(0, 10) : rankingData.slice(0, 5)).map(function (item) {
                                        return (
                                            <React.Fragment key={item.id}>
                                                <div className="ranking-item">
                                                    <div className="item-content">
                                                        <h3 className="item-title">{item.title}</h3>
                                                        <div style={{ width: "100%", height: "2px", backgroundColor: "#B2BCC6", marginTop: "10px", marginBottom: "6px" }}>
                                                            <div style={{ width: Math.round((item.duration / rankingData[0].duration) * 100) + "%", height: "2px", backgroundColor: "#18A0FB" }} />
                                                        </div>
                                                        <div className="item-stats">
                                                            <div className="stat">
                                                                <span className="user-icon"><ViewersIcon /></span>
                                                                <span className="stat-number">{item.viewers}</span>
                                                            </div>
                                                            <div className="stat duration">
                                                                <span className="stat-number-duration">{minutesToHms(item.duration)}</span>
                                                                <span className="eye-icon"><EyeIcon /></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="rank-number">{item.rank}</div>
                                                </div>
                                                <div className="item-separator" />
                                            </React.Fragment>
                                        );
                                    })}
                                </div>

                                {rankingData.length > 5 && (
                                    <button
                                        className="see-more-btn"
                                        onClick={function () { setShowMoreRankings(!showMoreRankings); }}
                                    >
                                        {showMoreRankings ? "VOIR MOINS" : "VOIR PLUS"}
                                        <span className="arrow-down" style={showMoreRankings ? { transform: "rotate(180deg)" } : {}}>
                                            <SeeMoreArrow />
                                        </span>
                                    </button>
                                )}
                            </React.Fragment>
                        ) : (
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
                                <span style={{ color: "#999", fontSize: "14px" }}>Aucune donnée disponible</span>
                            </div>
                        )}
                    </div>

                    {/* Orateurs en vedette */}
                    <div className="ranking-container">
                        <div className="ranking-header">
                            <h1 className="main-title">Orateurs en vedette</h1>
                            <p className="date-range">{getPeriodLabel()}</p>
                        </div>

                        {speakersLoading ? (
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
                                <CommonLoader />
                            </div>
                        ) : speakersData.length > 0 ? (
                            <React.Fragment>
                                <div className="orateurs-list">
                                    {(showMoreSpeakers ? speakersData.slice(0, 10) : speakersData.slice(0, 5)).map(function (item, index) {
                                        return (
                                            <React.Fragment key={item.id}>
                                                <div className="ranking-item">
                                                    <div className="item-content">
                                                        <div className="item-image" style={{ marginRight: index > 2 ? "6px" : "0" }}>
                                                            {item.image ? (
                                                                <img
                                                                    src={item.image}
                                                                    alt={item.name}
                                                                    style={{ width: "40px", height: "40px", borderRadius: "50%", objectFit: "cover" }}
                                                                    onError={function (e) { e.target.style.display = "none"; }}
                                                                />
                                                            ) : (
                                                                <div style={{ width: "40px", height: "40px", borderRadius: "50%", backgroundColor: "#F1F2F4" }} />
                                                            )}
                                                            {index < 3 && <StarIcon color={STAR_COLORS[index]} />}
                                                        </div>
                                                        <div className="item-details">
                                                            <h3 className="item-title">{item.name}</h3>
                                                            <p className="item-description">{item.title}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="item-separator" />
                                            </React.Fragment>
                                        );
                                    })}
                                </div>

                                {speakersData.length > 5 && (
                                    <button
                                        className="see-more-btn"
                                        onClick={function () { setShowMoreSpeakers(!showMoreSpeakers); }}
                                    >
                                        {showMoreSpeakers ? "VOIR MOINS" : "VOIR PLUS"}
                                        <span className="arrow-down" style={showMoreSpeakers ? { transform: "rotate(180deg)" } : {}}>
                                            <SeeMoreArrow />
                                        </span>
                                    </button>
                                )}
                            </React.Fragment>
                        ) : (
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
                                <span style={{ color: "#999", fontSize: "14px" }}>Aucune donnée disponible</span>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
};

const mapStateToProps = function (state) {
    return {
        issuerId: state.auth.currentClient && state.auth.currentClient.id,
    };
};

const mapDispatchToProps = {
    getCategorieDevice,
    getStatsOverview,
    getBestTraining,
    getFormatRanking,
    getSpeakers,
    getLocalisation,
};

export default connect(mapStateToProps, mapDispatchToProps)(WebinarStatisticsPage);


// WEBPACK FOOTER //
// ./app/pages/Admin/WebinarStatisticsPage.js